<script>
import ValueComboBox from './ValueComboBox'

export default {
  name: 'CallToActionComboBox',
  components: {
    ValueComboBox
  },
  computed: {
    items() {
      return [
        { value: 'ADD_TO_CART', text: 'Add To Cart' },
        { value: 'APPLY_NOW', text: 'Apply Now' },
        { value: 'BOOK_TRAVEL', text: 'Book Travel' },
        { value: 'BUY', text: 'Buy' },
        { value: 'BUY_NOW', text: 'Buy Now' },
        { value: 'BUY_TICKETS', text: 'Buy Tickets' },
        { value: 'CALL', text: 'Call' },
        { value: 'CALL_ME', text: 'Call Me' },
        { value: 'CONTACT', text: 'Contact' },
        { value: 'CONTACT_US', text: 'Contact Us' },
        { value: 'DONATE', text: 'Donate' },
        { value: 'DONATE_NOW', text: 'Donate Now' },
        { value: 'DOWNLOAD', text: 'Download' },
        { value: 'EVENT_RSVP', text: 'Event RSVP' },
        { value: 'FIND_A_GROUP', text: 'Find A Group' },
        { value: 'FIND_YOUR_GROUPS', text: 'Find Your Groups' },
        { value: 'FOLLOW_NEWS_STORYLINE', text: 'Follow News Storyline' },
        { value: 'FOLLOW_PAGE', text: 'Follow Page' },
        { value: 'FOLLOW_USER', text: 'Follow User' },
        { value: 'GET_DIRECTIONS', text: 'Get Directions' },
        { value: 'GET_OFFER', text: 'Get Offer' },
        { value: 'GET_OFFER_VIEW', text: 'Get Offer View' },
        { value: 'GET_QUOTE', text: 'Get Quote' },
        { value: 'GET_SHOWTIMES', text: 'Get Show Times' },
        { value: 'INSTALL_APP', text: 'Install App' },
        { value: 'INSTALL_MOBILE_APP', text: 'Install Mobile App' },
        { value: 'LEARN_MORE', text: 'Learn More' },
        { value: 'LIKE_PAGE', text: 'Like Page' },
        { value: 'LISTEN_MUSIC', text: 'Listen Music' },
        { value: 'LISTEN_NOW', text: 'Listen Now' },
        { value: 'MESSAGE_PAGE', text: 'Message Page' },
        { value: 'MOBILE_DOWNLOAD', text: 'Mobile Download' },
        { value: 'MOMENTS', text: 'Moments' },
        { value: 'NO_BUTTON', text: 'No Button' },
        { value: 'OPEN_LINK', text: 'Open Link' },
        { value: 'ORDER_NOW', text: 'Order Now' },
        { value: 'PAY_TO_ACCESS', text: 'Pay To Access' },
        { value: 'PLAY_GAME', text: 'Play Game' },
        { value: 'PURCHASE_GIFT_CARDS', text: 'Purchase Gift Cards' },
        { value: 'RECORD_NOW', text: 'Record Now' },
        { value: 'REQUEST_TIME', text: 'Request Time' },
        { value: 'SAY_THANKS', text: 'Say Thanks' },
        { value: 'SEE_MORE', text: 'See More' },
        { value: 'SELL_NOW', text: 'Sell Now' },
        { value: 'SEND_A_GIFT', text: 'Send A Gift' },
        { value: 'SHARE', text: 'Share' },
        { value: 'SHOP_NOW', text: 'Shop Now' },
        { value: 'SIGN_UP', text: 'Sign Up' },
        { value: 'SOTTO_SUBSCRIBE', text: 'Sotto Subscribe' },
        { value: 'SUBSCRIBE', text: 'Subscribe' },
        { value: 'UPDATE_APP', text: 'Update App' },
        { value: 'USE_APP', text: 'Use App' },
        { value: 'USE_MOBILE_APP', text: 'Use Mobile App' },
        { value: 'VIDEO_ANNOTATION', text: 'Video Annotation' },
        { value: 'VISIT_PAGES_FEED', text: 'Visit Pages Feed' },
        { value: 'WATCH_MORE', text: 'Watch More' },
        { value: 'WATCH_VIDEO', text: 'Watch Video' },
        { value: 'WHATSAPP_MESSAGE', text: 'WhatsApp Message' },
        { value: 'WOODHENGE_SUPPORT', text: 'Woodhenge Support' }
      ]
    }
  }
}
</script>

<template>
  <value-combo-box @input="$emit('input', $event)" :items="items" label="Call-to-Action" v-bind="$attrs" />
</template>
